export default __webpack_public_path__ + "static/media/hero_right.c244615c.svg";